export const CardOnFileValidationMessages = {
    expirationMonthExpired:
        'Expiration month cannot be in the past for the selected year',
} as const;
